import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useEjnList } from '../../../contexts/ejn';
import { useEjnSelectedTab } from '../../../hook/useEjnSelectedTab';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '../../base-components/table/Table';
import { buildEjnTableData, columns } from './table-data';

export const EjnTable: React.FC = () => {
  const history = useHistory();

  const { extrajudicialNotifications } = useEjnList();
  const { selectedTab } = useEjnSelectedTab();

  const data = useMemo(() => {
    return extrajudicialNotifications.map((it) => buildEjnTableData(it));
  }, [extrajudicialNotifications]);

  const handleClick = useCallback(
    (id: string) => {
      history.push({
        pathname: `/notificacoes-extrajudiciais?id=${id}`,
      });
    },
    [history],
  );

  const columnData = columns(selectedTab)
    .filter((it) => it.show)
    .map((it) => it.name);

  return (
    <Table display={'table'}>
      <TableHead>
        <TableRow>
          {columnData.map((it) => (
            <TableCell key={it}>{it}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.length > 0 &&
          data.map((extrajudicialNotification) => (
            <TableRow
              key={extrajudicialNotification.key}
              onClick={() => handleClick(extrajudicialNotification.key)}
            >
              {extrajudicialNotification.columns
                .filter((it) => columnData.includes(it.name))
                .map((cell, index) => (
                  <TableCell key={`${cell.name}-${index}`}>
                    {cell.value}
                  </TableCell>
                ))}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
